import { render, staticRenderFns } from "./PortalNavbar.vue?vue&type=template&id=544253f0&scoped=true&"
import script from "./PortalNavbar.vue?vue&type=script&lang=js&"
export * from "./PortalNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544253f0",
  null
  
)

export default component.exports